export default __webpack_public_path__ + "static/media/logo_MVX.c3319a42.svg";